import * as Yup from 'yup'
import { NOT_APPLICABLE_FIELD_VALUE } from 'core/common/constants/datasheet'
import i18n from 'core/common/i18n'

export const RegulatoryInformationFormSchema = Yup.object().shape({
  anvisa: Yup.string()
    .trim()
    .test(
      'isNotApplicable',
      'ANVISA deve ter de 9 a 20 caracteres e permitir apenas ".", "/" e "-"',
      value => value === NOT_APPLICABLE_FIELD_VALUE || /^[a-zA-Z0-9./-]{9,20}$/.test(value)
    )
    .required(i18n.t('product.validations.required')),
  mapa: Yup.string()
    .trim()
    .test(
      'isNotApplicable',
      'MAPA deve ter de 4 a 10 caracteres e permitir apenas ".", "/" e "-"',
      value => value === NOT_APPLICABLE_FIELD_VALUE || /^[a-zA-Z0-9./-]{4,10}$/.test(value)
    )
    .required(i18n.t('product.validations.required')),
})
